/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_Mv3Inputs */

const en_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const ar_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إصدار_ثالث`)
};

const bn_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const de_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const es_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const fr_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const pt_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const zh_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const tr_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const ru_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

const pl_svtag_mv3 = /** @type {(inputs: Svtag_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MV3`)
};

/**
* | output |
* | --- |
* | "#MV3" |
*
* @param {Svtag_Mv3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_mv3 = /** @type {((inputs?: Svtag_Mv3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_Mv3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_mv3(inputs)
	if (locale === "bn") return bn_svtag_mv3(inputs)
	if (locale === "de") return de_svtag_mv3(inputs)
	if (locale === "es") return es_svtag_mv3(inputs)
	if (locale === "fr") return fr_svtag_mv3(inputs)
	if (locale === "pt") return pt_svtag_mv3(inputs)
	if (locale === "zh") return zh_svtag_mv3(inputs)
	if (locale === "tr") return tr_svtag_mv3(inputs)
	if (locale === "ru") return ru_svtag_mv3(inputs)
	if (locale === "pl") return pl_svtag_mv3(inputs)
	return en_svtag_mv3(inputs)
});